import Spin from "slotworks/state-machine/standard/states/spin";
import rainbowStacksComponents from "components/components";
import { DisableUIButtons } from "commands/ui-buttons";

export default class RainbowStacksSpin extends Spin {

    public onEnter() {
        DisableUIButtons();
        super.onEnter();
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/spin.ts